import pdfImg from "@assets/images/pdf.png";
import { getLocalizedValue } from "@modules/shared/utils";
import { trans } from "@mongez/localization";
import { DocumentFile } from "../types";

type GovernanceAndRegulatoryDocumentsProps = {
  documents: DocumentFile[];
};

export function GovernanceAndRegulatoryDocuments({
  documents,
}: GovernanceAndRegulatoryDocumentsProps) {
  return (
    <div className="bg-[#f7f9fc] py-10 lg:py-20">
      <div className="container flex flex-col gap-6 sm:gap-10">
        <div className="flex flex-col gap-3 text-base font-medium text-marine sm:gap-5 sm:text-lg lg:text-xl">
          <p>{trans("governanceAndRegulatoryDocuments.paragraph1")}</p>
          <p>{trans("governanceAndRegulatoryDocuments.paragraph2")}</p>
        </div>

        <div className="flex flex-col gap-3 rounded-[33px] border border-[#B3B3B3] p-6">
          <div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-[1fr,_minmax(200px,200px)]">
            <span className="ltr:ml-10 rtl:mr-10">{trans("title")}</span>
            <span className="hidden lg:block">{trans("fileDownload")}</span>
          </div>

          <div className="flex w-full flex-col gap-3">
            {documents.map((item) => (
              <a
                href={getLocalizedValue(item?.pdf)}
                target="_blank"
                download
                className="grid w-full cursor-pointer grid-cols-1 items-center gap-6 rounded-[16px] bg-white px-4 py-4 lg:grid-cols-[1fr,_minmax(200px,200px)] lg:rounded-[32px] lg:px-8 lg:py-4"
              >
                <span className="flex flex-col gap-2 text-sm font-semibold sm:text-base">
                  <span className="mt-2 flex">
                    {getLocalizedValue(item.title)}
                  </span>
                  <span className="flex items-center gap-3 font-light hover:underline lg:hidden">
                    {trans("download")}
                  </span>
                </span>
                <img
                  src={pdfImg}
                  alt="pdf"
                  className="hidden size-10 lg:block ltr:ml-10 rtl:mr-10"
                ></img>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
